import { render, staticRenderFns } from "./instructionUploadProof.vue?vue&type=template&id=42ae4546"
import script from "./instructionUploadProof.vue?vue&type=script&lang=js"
export * from "./instructionUploadProof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports